import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { importTuinaTherapistSchedule } from '@/service/tuina'
import ScheduleImportForm from './ScheduleImportForm'

const fromValue = (fields) => {
  const fileList = Array.isArray(fields.file) ? fields.file : []
  const fileItem = fileList[0]
  const originFileObj = fileItem && fileItem.originFileObj
  const body = {}
  if (originFileObj) body.file = originFileObj
  return body
}

class ScheduleImportModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    const { storeId, onSuccess } = this.props
    const fields = await form.current.validateFields()
    const formatFields = fromValue(fields)
    const body = { ...formatFields }
    if (storeId != null && storeId !== '') body.storeId = storeId
    await importTuinaTherapistSchedule(body)
    message.success('已导入')
    if (typeof onSuccess === 'function') onSuccess()
  }

  render () {
    const { children } = this.props
    return (
      <WrappedModal
        children={children}
        title="导入排班"
        okText="导入"
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={480}
        baseComponent={<ScheduleImportForm />}
        onOk={this.handleOk}
      />
    )
  }
}

export default ScheduleImportModal
